import { render } from "./ipDetect.vue?vue&type=template&id=065d778f&scoped=true"
import script from "./ipDetect.vue?vue&type=script&lang=js"
export * from "./ipDetect.vue?vue&type=script&lang=js"

import "./ipDetect.vue?vue&type=style&index=0&id=065d778f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065d778f"]])

export default __exports__